import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { postVersionApiCrud, type PostVersionRequest } from "@/generated/fastapi";

export async function postVersion(
  accessToken: string | null | undefined,
  request: PostVersionRequest,
) {
  const response = await postVersionApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to save version (${response.status})`);
  }

  return response.data;
}
